import Phaser from 'phaser'
import { formatScore } from '../utils/scoring'

export interface ScoreDisplayConfig {
  x: number
  y: number
  label?: string
  initialScore?: number
}

/**
 * Reusable score display component
 */
export class ScoreDisplay extends Phaser.GameObjects.Container {
  private scoreText: Phaser.GameObjects.Text
  private currentScore: number = 0

  constructor(scene: Phaser.Scene, config: ScoreDisplayConfig) {
    super(scene, config.x, config.y)

    const { label = 'Score', initialScore = 0 } = config
    this.currentScore = initialScore

    // Background
    const bg = scene.add.rectangle(0, 0, 160, 50, 0x000000, 0.5)
    bg.setStrokeStyle(2, 0xffffff, 0.3)

    // Label
    const labelText = scene.add.text(-70, -8, label, {
      fontFamily: 'system-ui',
      fontSize: '14px',
      color: '#ffffff',
    })
    labelText.setOrigin(0, 0.5)
    labelText.setAlpha(0.8)

    // Score value
    this.scoreText = scene.add.text(70, -8, formatScore(initialScore), {
      fontFamily: 'system-ui',
      fontSize: '24px',
      fontStyle: 'bold',
      color: '#ffffff',
    })
    this.scoreText.setOrigin(1, 0.5)

    this.add([bg, labelText, this.scoreText])
    scene.add.existing(this)
  }

  /**
   * Update the displayed score with animation
   */
  setScore(score: number, animate: boolean = true): void {
    this.currentScore = score
    this.scoreText.setText(formatScore(score))

    if (animate) {
      this.scene.tweens.add({
        targets: this.scoreText,
        scale: 1.2,
        duration: 100,
        yoyo: true,
        ease: 'Quad.easeOut',
      })
    }
  }

  /**
   * Add to the current score
   */
  addScore(points: number, animate: boolean = true): number {
    this.currentScore += points
    this.setScore(this.currentScore, animate)
    return this.currentScore
  }

  /**
   * Get current score value
   */
  getScore(): number {
    return this.currentScore
  }
}
